<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group :label="sample.identifier" :label-cols="3">
          <b-form-input
            type="text"
            v-model="sample.sample_feed_mixer_efficiency.type"
            disabled
            placeholder="Sample Type"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col v-if="sampleListLength > 1" cols="1" class="pl-0">
        <b-button class="px-0" variant="danger" block @click="removeSample"
          ><i class="fal fa-trash"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FeedMixerSampleFormGroup",
  props: {
    sample: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number,
      default: 0
    },
    sampleListLength: {
      type: Number,
      default: 0
    }
  },
  methods: {
    removeSample() {
      this.$emit("onSampleListChange", {
        action: "remove",
        sample_index: this.index
      });
    }
  }
};
</script>
